import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "chevron_open", "chevron_closed", "localization_checkboxes" ]

  initialize() {
    // expand the localizations if there are checked localizations
    const localizations = this.localization_checkboxesTarget;
    const hasCheckedLocalizations = localizations.querySelectorAll('input[type="checkbox"]:checked').length > 0;
    if( hasCheckedLocalizations ) {
      this.localization_checkboxesTarget.classList.remove('hidden');
      this.chevron_openTarget.classList.remove('hidden');
      this.chevron_closedTarget.classList.add('hidden');
    }
  }

  toggle_oncologic_localizations() {
    this.localization_checkboxesTarget.classList.toggle('hidden');
    this.chevron_openTarget.classList.toggle('hidden');
    this.chevron_closedTarget.classList.toggle('hidden');
  }

  select_all_in_group(event) {
    event.preventDefault();
    const checkboxes = this.localization_checkboxesTarget.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(cb => {
      if (!cb.checked) {
        cb.checked = true;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}
